
import a from "./family-friends.svg";
import b from "./offenders.svg";
import c from "./victims.svg";
import d from "./general-public.svg";
import arrow from "./drop-arrows-down.svg";
import { StyledDd } from "./Menu.styles";

export const Menu = ({menuData}) => {

    const genLink = (subData, idx) => {
        if (idx === 1) {
            let grands = subData.map((link, i) => {
                if (link.GrandMenu.length > 0) {
                    return <li key={i} className="dropdown-menu-list-column col-7">
                        <dl className="dropdown-menu-list">
                            <dt><a href={link.Url} title={link.Name}>{link.Name}</a></dt>
                            {link.GrandMenu.map((glink, j) => {
                                return <dd key={j}><a href={glink.Url} title={glink.Name}>{glink.Name}</a></dd>
                            })}
                        </dl>
                    </li>
                }
                return null;
            });

            let info = <li className="dropdown-menu-list-column col-7">
                <dl className="dropdown-menu-list">
                    <dt className="body-bold">General Information</dt>
                    {subData.map((link, i) => {
                        /// filtering in the header api is not working for the below links!
                        if (link.Id !== 1341 && link.Id !== 1343) {
                            return <dd key={i}><a href={link.Url} title={link.Name}>{link.Name}</a></dd>
                        } else {
                            return null;
                        }
                        
                    })}
                </dl>
            </li>;

            return <>{grands}{info}</>
        } else {
            return subData.map((link, i) => {
                return <li key={i}><a href={link.Url} title={link.Name}>{link.Name}</a></li>
            })
        }
    }

    const genSubmenu = (subData, i) => {
        let cl = "dropdown-menu col-16";

        // this is not ideal, will fix this later
        if (i === 3){
            cl = "dropdown-menu col-17";
        }

        if (i === 1 ) {
            cl = "dropdown-menu three-col-dropdown col-27";
        }

        if (subData) {
            return <ul className={cl}>{genLink(subData, i)}</ul>
        } else {
            return null
        }
    }

    const genImage = (idx, name) => {
        switch(idx) {
            case 0:
                return <img src={a} className="nav-icon" aria-hidden="true" alt="()" />
            case 1:
                return <img src={b} className="nav-icon" aria-hidden="true" alt="()" />
            case 2:
                return <img src={c} className="nav-icon" aria-hidden="true" alt="()" />
            case 3:
                return <img src={d} className="nav-icon" aria-hidden="true" alt="()" />
            default:
                return <img src={a} className="nav-icon" aria-hidden="true" alt="()" />
        }
    }

    const genDDNavLink = () => {
        return menuData.map((dd, i) => {
            if (dd.SubMenu.length > 0) {
                return <StyledDd key={i} className="dropdown-navlink">
                    <a href={dd.Url} title={dd.Name}>
                        {genImage(i, dd.Name)}
                        <span className="accessibility-hidden">Resources For&nbsp;</span>
                        <span>{dd.Name}</span>
                        <img src={arrow} aria-hidden="true" alt="more" />
                    </a>
                    {genSubmenu(dd.SubMenu, i)}
                </StyledDd>
            } else {
                return <StyledDd key={i} className="dropdown-navlink">
                    <a href={dd.Url} title={dd.Name}>
                        {genImage(i, dd.Name)}
                        <span className="accessibility-hidden">Resources For&nbsp;</span>
                        <span>{dd.Name}</span>
                    </a>
                </StyledDd>
            }
            
        })
    }

    return <nav id="main-nav">
        <dl id="main-nav-list" className="content-wrapper dark-background">
            <dt id="resources-label" aria-hidden="true">Resources For:</dt>
            {genDDNavLink()}
        </dl>
    </nav>;
}